export default "__VITE_ASSET__MHLsQHgc__"